var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightG = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 14,
  fill: "none",
  viewBox: "0 0 13 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00A32E",
  d: "M11.376 5.317a2 2 0 0 1 0 3.366L3.58 13.685C2.249 14.538.5 13.583.5 12V2C.5.417 2.249-.538 3.58.316z"
})));
export { SvgRightG as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMyAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjM3NTggNS4zMTY2QzEyLjYwMjYgNi4xMDM2IDEyLjYwMjYgNy44OTY0IDExLjM3NTggOC42ODM0TDMuNTc5OSAxMy42ODQ1QzIuMjQ4NzkgMTQuNTM4NCAwLjUgMTMuNTgyNiAwLjUgMTIuMDAxMUwwLjUgMS45OTg5QzAuNSAwLjQxNzQzMyAyLjI0ODc4IC0wLjUzODQxIDMuNTc5OSAwLjMxNTUwMkwxMS4zNzU4IDUuMzE2NloiIGZpbGw9IiMwMEEzMkUiLz4KPC9zdmc+Cg==";